import React from 'react';
import './MaintainerPageShell.css';

export type MaintainerPageShellProps = {
  title: string;
  /** Texto o nodo de meta (conteo, estado de carga, etc.) */
  meta?: React.ReactNode;
  /** Ícono de módulo (reconocimiento visual) — inyectado por el consumidor */
  icon?: React.ReactNode;
  /** Acciones del header (botón crear, etc.) — inyectadas por el consumidor */
  actions?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
};

/**
 * Shell de página mantenedora. No conoce el dominio:
 * solo compone título, meta, acciones y contenido.
 */
const MaintainerPageShell: React.FC<MaintainerPageShellProps> = ({
  title,
  meta,
  icon,
  actions,
  children,
  className = '',
}) => (
  <div className={`maintainer-page ${className}`.trim()}>
    <header className="maintainer-page__header">
      <div className="maintainer-page__heading">
        <div className="maintainer-page__title-row">
          {icon ? (
            <span className="maintainer-page__icon" aria-hidden>
              {icon}
            </span>
          ) : null}
          <h1 className="maintainer-page__title">{title}</h1>
        </div>
        {meta != null && meta !== false ? (
          <div className="maintainer-page__meta">{meta}</div>
        ) : null}
      </div>
      {actions ? <div className="maintainer-page__actions">{actions}</div> : null}
    </header>
    <div className="maintainer-page__body">{children}</div>
  </div>
);

export default MaintainerPageShell;
